import load from "./load"
export let _=load